import { Component, OnInit, ElementRef } from '@angular/core';
import { RemessaService } from '../../../../../shared/services/remessa/remessa.service';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';
import * as moment from 'moment';
import { urls } from '../../../../../../environments/environment';
import { CedenteService } from '../../../../../shared/services/cedente/cedente.service';

declare var $: any;

@Component({
  selector: 'app-remessa',
  templateUrl: './remessa.component.html',
  styleUrls: ['./remessa.component.scss']
})
export class RemessaComponent implements OnInit {
  public remessas: any[];
  public qtdBoletosSemRemessa = 0;
  public cedentes: any = [];
  public cedente: any = null;
  public table: any = null;
  public error = false;
  public loaded = false;

  constructor(
    private remessaService: RemessaService,
    private cedenteService: CedenteService,
    private localStorage: LocalStorageService,
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    this.getCedentes();
    this.getQtdBoletosSemRemessa();
    this.getRemessas();
  }

  getCedentes() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.cedenteService.obterPorContaId(user.PersonId).subscribe((data: any) => {
      if (data && data.length > 0) {
        data.forEach((cedente) => {
          if (cedente.Padrao) {
            this.cedente = cedente;
          }
        });
      }
      this.cedentes = data;
    }, (err) => {
      console.error(err);
    });
  }

  getQtdBoletosSemRemessa() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.remessaService.obterQtdBoletoSemRemessas(user.PersonId).subscribe((data: any) => {
      this.qtdBoletosSemRemessa = data;
    }, (err) => {
      console.error(err);
    });
  }

  getRemessas() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.remessaService.obterRemessas(user.PersonId).subscribe((data: any) => {
      this.remessas = data;

      this.remessas.forEach((remessa) => {
        remessa.DataCadastro = moment(remessa.DataCadastro).format('DD/MM/YYYY');
      });

      this.remessas.sort(function(a, b) {
        if (a.DataCadastro > b.DataCadastro) { return -1; }
        if (a.DataCadastro  < b.DataCadastro) { return 1; }
        return 0;
      });

      this.showData();
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  selectCedente(cedente) {
    this.cedente = cedente;
  }

  compare(a, b) {
    if (a.DataCadastro > b.DataCadastro) {
      return -1;
    }
    if (a.DataCadastro  < b.DataCadastro) {
      return 1;
    }
    return 0;
  }

  gerarRemessas() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    const user = this.localStorage.get('login');
    this.remessaService.gerarRemessa(user.PersonId, this.cedente.CedenteId).subscribe((data) => {
      this.qtdBoletosSemRemessa = 0;

      if (this.table) {
        this.table.destroy();
        this.getRemessas();
      }

      this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
    }, (err) => {
      console.error(err);
    });
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;
    this.table = $('#master-detail-table-remessa').DataTable({
      scrollX: true,
      destroy: true,
      paging: false,
      searching: false,
      processing: false,
      info: true,
      data: self.remessas,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function() {
        self.loaded = true;

        if (self.remessas && self.remessas.length === 0) {
          $('#master-detail-table-remessa_info').html('0 - 0 de 0');
        }
      },
      columns: [
        {
          title: '',
          class: 'details-control',
          orderable: false,
          data: null,
          defaultContent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">' +
                            '<title>icon-mais</title>' +
                            '<line x1="3" y1="7" x2="11" y2="7" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                            '<line x1="7" y1="3" x2="7" y2="7" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                            '<line x1="7" y1="7" x2="7" y2="11" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                          '</svg>'
        },
        { title: 'Arquivo', data: 'NomeArquivo' },
        { title: 'Data Remessa', data: 'DataCadastro' },
        {
          title: '',
          class: 'download-remessa',
          data: null,
          orderable: false,
          render: function(data) {
            return '<a data=arquivo="' + data.NomeArquivo + '" ' +
                    'data-remessa-id="' + data.RemessaId + '" ' +
                    'class="pull-right btn-download-remessa btn">' +
                      '<span class="glyphicon glyphicon-download-alt"></span>' +
                    '</a>';
          },
        },
      ],
    });

    const btnDownloadRemessa = this.elRef.nativeElement.querySelector('.btn-download-remessa');

    if (btnDownloadRemessa) {
      btnDownloadRemessa.addEventListener('click', function() {
        const path = urls.apiBase + '/Remessas/Download?remessaId=';

        const remessaId = btnDownloadRemessa.getAttribute('data-remessa-id');
        const fileName = btnDownloadRemessa.getAttribute('data-arquivo');

        const a = document.createElement('a');
        a.download = fileName;
        a.href = path + remessaId;
        a.target = '_blank';
        a.click();
      });
    }

    const detailRows = [];

    $('#master-detail-table-remessa tbody').on( 'click', 'tr td.details-control', function () {
      const tr = $(this).closest('tr');
      const row = self.table.row( tr );
      const idx = detailRows.indexOf(tr.attr('id'));

      if (row.child.isShown()) {
        $('div.slider', row.child()).slideUp(function () {
          tr.removeClass('details');
          tr.removeClass('shown');
          row.child.hide();
        });

        detailRows.splice( idx, 1 );
      } else {
        tr.addClass('details');

        row.child('<button class="btn btn-registrar loading"></button>').show();

        self.remessaService.obterBoletosPorRemessaId(row.data().RemessaId).subscribe((data) => {
          row.child(self.format(data)).show();
          tr.addClass('shown');
          $('div.slider', row.child()).slideDown();
        }, (err) => {
          console.error(err);
        });

        if ( idx === -1 ) {
          detailRows.push( tr.attr('id') );
        }
      }
    });

    self.table.on('draw', function () {
      detailRows.forEach(function(id, i) {
        const detailsControl = this.elRef.nativeElement.querySelector('#' + id + 'td.details-control');
        const event = document.createEvent('Event');
        event.initEvent('click', true, true);
        detailsControl.dispatchEvent(event);
      });
    });
  }

  format(d) {
    let tr = '';

    d.forEach((boleto) => {
      tr += '<tr>' +
              '<td>' + moment(boleto.DataVencimento).format('DD/MM/YYYY') + '</td>' +
              '<td>' + boleto.SacadoNome + '</td>' +
              '<td>' + boleto.Valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }) + '</td>' +
              '<td>' +
                '<a class="pull-right" target="_blank" href="' + boleto.BoletoUrl + '">' +
                  '<button class="btn">' +
                    '<span class="glyphicon glyphicon-eye-open"></span>' +
                  '</button>' +
                '</a>' +
                '<a class="pull-right" target="_blank" download="' + boleto.NomeArquivo + '" href="' + boleto.BoletoUrl + '">' +
                  '<button class="btn">' +
                    '<span class="glyphicon glyphicon-download-alt"></span>' +
                  '</button>' +
                '</a>' +
              '</td>' +
            '</tr>';
    });

    return  '<div class="slider">' +
              '<table style="width: 100%;">' +
                '<thead>' +
                  '<tr>' +
                    '<th>Dt Vencimento</th>' +
                    '<th>Nome do Sacado</th>' +
                    '<th>Valor</th>' +
                    '<th></th>' +
                  '<tr>' +
                '</thead>' +
                '<tbody>' +
                  tr +
                '</tbody>' +
              '</table>' +
            '</div>';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/boletos/remessa/remessa.component.ts